import VueI18n from 'vue-i18n';
import en from './locales/en.json';
import { getFirstEligibleLocale, remapMessages } from '@/libs/utils/locales';
import { isEmpty } from 'lodash';

const AUTH_LOCALES = { en };

export function createLocales(Vue) {
    Vue.use(VueI18n);

    // Plugins configuration
    const i18n = new VueI18n({
        locale: 'en',
        fallbackLocale: 'en',
        messages: { ...AUTH_LOCALES } // `vue-i18n` mutates it, hence the copy
    });

    /**
     * Updates the default messages with the given ones, then sets the locale the pages
     * are rendered in and the chain to walk when a key is missing from that locale.
     *
     * @param {object} dictionary
     * @param {string[]} [supportedLang] the languages supported by the event, ordered by priority
     * @param {string} [preferredLocale]
     */
    Vue.prototype.$updateMessages = function(dictionary, supportedLang, preferredLocale) {
        const messages = remapMessages(this.$i18n.messages, dictionary);
        // Backward compatibility: without an explicit list, every translated language is supported
        const locales = isEmpty(supportedLang) ? Object.keys(messages) : supportedLang;

        for (const lang of Object.keys(messages)) {
            if (lang === 'en' || locales.includes(lang)) {
                this.$i18n.setLocaleMessage(lang, messages[lang]);
            }
        }

        // Keys missing from the selected locale are looked up in the remaining supported
        // languages, in order, and only then in English
        this.$i18n.fallbackLocale = isEmpty(supportedLang) ? 'en' : [ ...supportedLang, 'en' ];
        this.$i18n.locale = getFirstEligibleLocale({ locales, preferredLocale });
    };

    return i18n;
}
